import { Button, Modal, NumberInput, RadioButton } from "components"
import { useEffect, useState } from "react"

type ModalInputFormulaProps = {
  show: boolean
  onHide: () => void
  defaultValue?: number
  onApply?: (formula: "fixed" | "amount" | "percentage", value: number) => void
}

export const ModalInputFormula = ({ show, onHide, defaultValue, onApply }: ModalInputFormulaProps) => {
  const [formula, setFormula] = useState<"fixed" | "amount" | "percentage" | null>(null)

  const [fixedValue, setFixedValue] = useState<number | null>(null)
  const [amountValue, setAmountValue] = useState<number | null>(null)
  const [percentageValue, setPercentageValue] = useState<number | null>(null)

  useEffect(() => {
    if (show) {
      setFixedValue(defaultValue ?? null)
      setAmountValue(null)
      setPercentageValue(null)
      setFormula("fixed")
    }
  }, [show, defaultValue])
  
  const handleApply = () => {
    if (!formula) return
    if (formula === "fixed" && fixedValue !== null) onApply?.("fixed", fixedValue)
    if (formula === "amount" && amountValue !== null) onApply?.("amount", amountValue)
    if (formula === "percentage" && percentageValue !== null) onApply?.("percentage", percentageValue)
    onHide()
  }

  return (
    <Modal 
      isOpen={show} 
      size="md" 
      closeModal={onHide} 
      title="Apply Formula"
      style={{ maxWidth: 600, borderRadius: 10 }}
    >
      <Modal.Body style={{ minHeight: 260, maxHeight: "none", height: "auto" }}> 
        <div className="lg:flex lg:justify-between lg:items-center mb-2">
          <RadioButton 
            id="fixed-ammount" 
            label="Apply fixed ammount to each month" 
            name="formulaType"
            checked={formula === "fixed"}
            onChange={() => {
              setFormula("fixed")
              setFixedValue(defaultValue ?? null)
              setAmountValue(null)
              setPercentageValue(null)
            }}
          />
          <NumberInput 
            className="w-full lg:w-[200px] h-full lg:h-[40px] mr-[22px]" 
            inputClass="text-right" 
            decimalSeparator="."
            thousandSeparator=","
            value={fixedValue !== null ? fixedValue.toString() : ""}
            onValueChange={(e) => setFixedValue(Number(e.floatValue))}
            disabled={formula !== "fixed"}
          />
        </div>
        <div className="lg:flex lg:justify-between lg:items-center mb-2">
          <RadioButton 
            id="by-ammount"  
            label="Adjust by ammount each month" 
            name="formulaType"
            checked={formula === "amount"}
            onChange={() => {
              setFormula("amount")
              setAmountValue(defaultValue ?? null)
              setFixedValue(null)
              setPercentageValue(null)
            }}
          />
          <NumberInput 
            className="w-full lg:w-[200px] h-full lg:h-[40px] mr-[22px]" 
            inputClass="text-right" 
            decimalSeparator="."
            thousandSeparator=","
            value={amountValue !== null ? amountValue.toString() : ""}
            onValueChange={(e) => setAmountValue(Number(e.floatValue))}
            disabled={formula !== "amount"}
          />
        </div>
        <div className="lg:flex lg:justify-between lg:items-center mb-2">
          <RadioButton 
            id="by-percentage"  
            label="Adjust by percentage each month" 
            name="formulaType"
            checked={formula === "percentage"}
            onChange={() => {
              setFormula("percentage")
              setPercentageValue(30)
              setFixedValue(null)
              setAmountValue(null)
            }}
          />
          <div className="flex items-center gap-2">
            <NumberInput 
              className="w-full lg:w-[200px] h-full lg:h-[40px]" 
              inputClass="text-right" 
              decimalSeparator="."
              thousandSeparator=","
              value={percentageValue !== null ? percentageValue.toString() : ""}
              onValueChange={(e) => setPercentageValue(Number(e.floatValue))}
              disabled={formula !== "percentage"}
            />
            <div>%</div>
          </div>
        </div>

        <div className="flex justify-end mt-[30px] w-full">
          <div className="lg:flex gap-2">
            <Button 
              className="text-white w-full lg:w-[180px] rounded-[10px] bg-[#4DB82C] hover:bg-[#41A322]"
              onClick={handleApply}
            >APPLY
            </Button> 
            <Button 
              className="text-white w-full lg:w-[180px] rounded-[10px] bg-[#A8A8A8] hover:bg-[#8C8B8B]"
              onClick={onHide}
            >CANCEL
            </Button> 
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}